import axios from '@/config/httpConfig'
//获取预测角色树信息
export function getRoles () {
    return axios.post('/salesFunnel/getRoles')
}
//获取记录类型列表
export function getRecordTypes () {
    return axios.post('/salesFunnel/getRecordTypes')
}
//获取列表表头字段  最底层
export function getListHeaders () {
    return axios.post('/salesFunnel/listHeaders')
}
//获取业务机会列表数据   最底层
export function getListData (data) {
    return axios.post('/salesFunnel/listData',data)
}
//获取销售漏斗统计信息   漏斗图  以及  右侧表格
export function getQueryFunnel (data) {
    return axios.post('/salesFunnel/queryFunnel',data)
}
//获取业务机会阶段推进阶梯信息
export function jieduanFunnelData (data) {
  return axios.post('/salesFunnel/jieduanFunnelData',data)
}
//获取业务机会阶段推进阶梯信息下面表格数据
export function jieduanListData (data) {
  return axios.post('/salesFunnel/jieduanListData',data)
}